import styled from "styled-components";

import { KeypadWrapperStyles, SoundButtonWrapper } from "./Wrappers.Default";

export const MinimalContainer = styled.div`
  ${KeypadWrapperStyles};
  height: 0px; /* IE fix */
  min-height: 1.8em;

  > section {
    display: flex;
    align-self: stretch;
  }

  /* Left buttons */
  > section:nth-of-type(1) {
    flex: 0 0 4.1em;
    justify-content: flex-start;
    align-items: center;

    margin-left: 0.9em;

    > div:first-child {
      margin-right: 0.6em;
    }
  }

  /* Right buttons */
  > section:nth-of-type(3) {
    flex: 0 0 4.1em;
    justify-content: flex-end;
    align-items: center;

    margin-right: 0.9em;

    > div:last-child {
      margin-left: 0.6em;
    }
  }

  > section:nth-of-type(2) {
    overflow: hidden;

    flex: 1 1 100%;
    justify-content: space-around;
    align-items: center;

    color: white;

    > div {
      align-items: center;
      height: 100%;
      margin: 0 0.2em;
    }

    /* freeSpins value */
    > div:nth-of-type(1) {
      flex: 0 0 6em;
    }
  }
`;

// What's the difference between Wrapper and Container?
export const SoundButtonMinimalWrapper: any = styled(SoundButtonWrapper)`
  > a {
    width: 1.7em;
    height: 1.7em;
  }
`;

SoundButtonMinimalWrapper.displayName = "SoundButtonMinimalWrapper";

export const SoundButtonMinimalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

SoundButtonMinimalContainer.displayName = "SoundButtonMinimalContainer";
